import { render, staticRenderFns } from "./ManageSystemsDecreaseModal.vue?vue&type=template&id=336c36be&scoped=true&"
import script from "./ManageSystemsDecreaseModal.vue?vue&type=script&lang=ts&"
export * from "./ManageSystemsDecreaseModal.vue?vue&type=script&lang=ts&"
import style0 from "./ManageSystemsDecreaseModal.vue?vue&type=style&index=0&id=336c36be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336c36be",
  null
  
)

export default component.exports